module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "overflow-y": "auto",
      "overflow-x": "hidden"
    },
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "allmap"
    }
  }), _vm._v(" "), (_vm.shouldShow) ? _c('router-view') : _vm._e(), _vm._v(" "), (_vm.shouldShow) ? _c('Loading') : _vm._e(), _vm._v(" "), _c('div', [_c('confirm', {
    attrs: {
      "confirm-text": "升级体验",
      "cancel-text": "回到首页"
    },
    on: {
      "on-cancel": _vm.comeBack,
      "on-confirm": _vm.comeGo
    },
    model: {
      value: (_vm.ConfirmShow),
      callback: function($$v) {
        _vm.ConfirmShow = $$v
      },
      expression: "ConfirmShow"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("请升级到最新版使用该功能")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12be21ba"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 383
// module chunks = 1